<div class="container">
  <div class="text">You are not authorized to access this page</div>
</div>
